import oGet from 'lodash/get'
import { action, computed, observable } from 'mobx'
import payLoadApi from '../api/payload'

type FaxData = {
  contactCount?: number
  creditPageCount?: number
  draftCount?: number
  inboxCount?: number
  outboxCount?: number
  period?: null
  sentCount?: number
  starCount?: number
  trashCount?: number
  unReadCount?: number
}

class FaxUsage {
  @observable data: FaxData = {
    contactCount: 0,
    creditPageCount: 0, //积分换算的页数
    draftCount: 0,
    inboxCount: 0,
    outboxCount: 0,
    period: null,
    sentCount: 0,
    starCount: 0,
    trashCount: 0,
    unReadCount: 0,
  }

  @computed get remainingPages() {
    const maxPages = oGet(this.data, 'period.maxPages', 1)
    const recvPages = oGet(this.data, 'period.recvPages', 0)
    const sentPages = oGet(this.data, 'period.sentPages', 0)
    return maxPages - (recvPages + sentPages)
  }

  // 是否可以使用pages （剩余 pages > 0）
  @computed get canUsePages() {
    return this.remainingPages > 0
  }

  @computed get hasCreditPageCount() {
    const num = this.data.creditPageCount || 0
    return num > 0
  }

  @action async requestFaxUsage() {
    const data = await payLoadApi.getFaxUsage()
    this.data = data as FaxData
  }

  @action asyncFaxUsage() {
    this.requestFaxUsage()
  }

  updateLocalData(exec: (data: FaxData) => FaxData): void
  updateLocalData(data: FaxData): void
  @action updateLocalData(param: FaxData | ((data: FaxData) => FaxData)) {
    if (typeof param === 'function') {
      const data = param(this.data)
      this.data = Object.assign(this.data, data)
    } else {
      this.data = Object.assign(this.data, param)
    }
  }

  @action initial() {
    this.requestFaxUsage()
  }
}

export default FaxUsage
